/* import __COLOCATED_TEMPLATE__ from './list-page-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();